﻿import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { CustomerLicenseForm } from './license.form';
import { Observable } from 'rxjs';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { FormatDateService } from '../../../../../shared/misc/service/format-date.service';

@Component({
    selector: 'admin-customer-license',
    templateUrl: './license.component.html',
    styleUrls: ['./license.component.scss'],
})
export class AdminCustomerLicenseComponent extends AbstractFormComponent implements OnInit, AfterViewInit {
    license$: Observable<any>;
    features: string[] = [
        'video',
        'print',
        'greenscreen',
        'facial-recognition',
        'qr-website',
        'ai-removal',
        'autoprint',
        'direct-print',
        'live-preview',
        'lookout-video',
        'reel-video',
        'vip-photo-codes',
        'narrowcasting',
        'photo-preview-screen',
        'regular-digital-product',
        'regular-foreground',
        'perfectly-clear-filter',
        'tier-pricing',
        'public-ingest-api',
        'skip-greenscreen-overlay',
        'skip-foreground-overlay',
        'greenscreen-set-v2',
        'creation-station',
        'video-facial-recognition',
        'cluster-sheet',
        'multi-camera',
        'diner-show',
        'multi-face-search',
        'table-selector',
        'child-face-search',
        'order-kiosk-packages',
        'photo-website-v2',
        'momants',
        'video-camera',
        'prepurchased-video',
        'free-print',
        'multiple-print-stations',
        'ai-edit',
        'grotto',
    ];
    featuresLabels: string[] = [
        'Video',
        'Print',
        'Greenscreen',
        'Face search',
        'QR Website',
        'AI Background Removal',
        'Autoprint',
        'Direct Print',
        'Live Preview',
        'Video 360',
        'Reel video',
        'VIP Photo Codes',
        'Narrowcasting',
        'Photo Preview Screen',
        'Regular Digital Photo Package',
        'Regular photo foreground',
        'Perfectly Clear Filter',
        'Tier Pricing',
        'Public Ingest API',
        'Don\’t show overlay on green screen',
        'Don\’t show overlay on foreground',
        'Greenscreen Set V2',
        'Creation Station',
        'Video Facial Recognition',
        'Cluster Sheet',
        'Multi Camera',
        'Diner Show',
        'Multi Face Search',
        'Table Selector',
        'Child Face Search',
        'Order Kiosk Packages',
        'New Photo Website',
        'Momants',
        'Video Camera',
        'Prepurchased Video',
        'Free Printing',
        'Multiple Print Stations',
        'AI Edit',
        'Grotto',
    ];
    featuresObj: Record<string, string> = {
        video: 'Video',
        print: 'Print',
        greenscreen: 'Greenscreen',
        'facial-recognition': 'Face search',
        'qr-website': 'QR Website',
        'ai-removal': 'AI Background Removal',
        autoprint: 'Autoprint',
        'direct-print': 'Direct Print',
        'live-preview': 'Live Preview',
        'lookout-video': 'Video 360',
        'reel-video': 'Reel video',
        'vip-photo-codes': 'VIP Photo Codes',
        narrowcasting: 'Narrowcasting',
        'photo-preview-screen': 'Photo Preview Screen',
        'regular-digital-product': 'Regular Digital Photo Package',
        'regular-foreground': 'Regular photo foreground',
        'perfectly-clear-filter': 'Perfectly Clear Filter',
        'tier-pricing': 'Tier Pricing',
        'public-ingest-api': 'Public Ingest API',
        'skip-greenscreen-overlay': 'Don’t show overlay on green screen',
        'skip-foreground-overlay': 'Don’t show overlay on foreground',
        'greenscreen-set-v2': 'Greenscreen Set V2',
        'creation-station': 'Creation Station',
        'video-facial-recognition': 'Video Facial Recognition',
        'cluster-sheet': 'Cluster Sheet',
        'multi-camera': 'Multi Camera',
        'diner-show': 'Diner Show',
        'multi-face-search': 'Multi Face Search',
        'table-selector': 'Table Selector',
        'child-face-search': 'Child Face Search',
        'order-kiosk-packages': 'Order Kiosk Packages',
        'photo-website-v2': 'New Photo Website',
        momants: 'Momants',
        'video-camera': 'Video Camera',
        'prepurchased-video': 'Prepurchased Video',
        'free-print': 'Free Printing',
        'ai-edit': 'AI Edit',
        grotto: 'Grotto',
    };

    pricingModels: ISelectOption[] = [
        {
            label: 'Plan',
            value: 'plan',
        },
        {
            label: 'Trial',
            value: 'isTrial',
        },
        {
            label: 'Unlimited',
            value: 'unlimited',
        },
        {
            label: 'Pay as you go',
            value: 'payAsYouGo',
        },
    ];
    printModes: ISelectOption[] = [
        {
            label: 'Staffed',
            value: 'staffed',
        },
        {
            label: 'Self Service',
            value: 'self-service',
        },
    ];
    blockOptions: ISelectOption[] = [
        {
            value: true,
            label: 'Yes',
        },
        {
            value: false,
            label: 'No',
        },
    ];
    dpConfig: Partial<BsDatepickerConfig> = {
        containerClass: 'theme-default',
    };

    constructor(
        formBuilder: CustomerLicenseForm,
        httpClient: HttpClient,
        toastrService: ToastrService,
        urlBuilder: AdminUrlBuilder,
        router: Router,
        route: ActivatedRoute,
        private formatDateService: FormatDateService
    ) {
        super(formBuilder, httpClient, toastrService, router, route, urlBuilder);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.formMode = 'update';
        this.license$ = new Observable((obs) => {
            this.httpClient
                .get<any>('/admin/license', {
                    params: {
                        limit: '999',
                    },
                })
                .subscribe(
                    (response) => {
                        obs.next(
                            response.rows.map((row) => {
                                return <ISelectOption>{ value: row.id, label: row.name };
                            })
                        );
                        obs.complete();
                    },
                    (error: any) => {
                        obs.next(error);
                        obs.complete();
                    }
                );
        });
        this.populate().subscribe((data: any) => {});

        this.form.controls.isBlocked.valueChanges.subscribe((value) => {
            value = JSON.parse(value);
            if (value) {
                this.form.controls.hasPrintBlocked.patchValue(value);
                this.form.controls.hasPhotoBlocked.patchValue(value);
            }
            this.form.controls.isBlocked.patchValue(value, { emitEvent: false });
        });
        this.form.controls.hasPhotoBlocked.valueChanges.subscribe((value) => {
            value = JSON.parse(value);
            this.form.controls.hasPhotoBlocked.patchValue(value, { emitEvent: false });
        });
        this.form.controls.hasPrintBlocked.valueChanges.subscribe((value) => {
            value = JSON.parse(value);
            this.form.controls.hasPrintBlocked.patchValue(value, { emitEvent: false });
        });
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    protected getUrl(): string {
        return `/customer/${this.route.parent.snapshot.params.id}/license`;
    }

    onDateChange(date) {
        this.form.controls.startDate.patchValue(this.formatDateService.format(date, 'YYYY-MM-DD'));
    }

    submit(): void {
        // [ 'fixedPrice', 'photoUnitPrice', 'printUnitPrice', 'photoBlockPrice', 'printBlockPrice' ].forEach(f => {
        //   this.form.controls[f].patchValue(parseFloat(this.form.controls[f].value || 0));
        // });
        // [ 'license' ].forEach(f => {
        //   this.form.controls[f].patchValue(parseInt(this.form.controls[f].value || 0, 10));
        // });
        // this.form.controls.photosUnlimited.patchValue(!!this.form.controls.photosUnlimited.value);
        // this.form.controls.printsUnlimited.patchValue(!!this.form.controls.printsUnlimited.value);
        super.submit();
    }

    protected onSubmit(response: any): void {
        this.toastrService.success('Saved');
    }

    reset() {
        this.populate().subscribe();
    }
}
